import dynamic from "next/dynamic";
import SearchBarCareersConfig from "./search-bar-careers-config";
import SearchBarCareersAdvancedConfig from "./search-bar-careers-advanced-config";
const SearchBarCareersComponent = dynamic(()=>import("./search-bar-careers-component"));
export default {
    SearchBarCareersComponent,
    SearchBarCareersConfig,
    SearchBarCareersAdvancedConfig
};
